export default __webpack_public_path__ + "static/media/facebook.71096431.svg";